import React from 'react';

interface ColorPickerProps {
  id?: string;
  mode?: 'Palette' | 'Picker' | string;
  modeSwitcher?: boolean;
  inline?: boolean;
  showButtons?: boolean;
  change?: (args: { currentValue: { hex: string } }) => void;
}

export const ColorPickerComponent = ({ id, mode, inline, showButtons, change }: ColorPickerProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const hex = e.target.value;
    if (change) change({ currentValue: { hex } });
  };

  return (
    <div id={id} className={`inline-block ${inline ? 'inline' : ''}`}>
      <input type="color" onChange={handleChange} />
      {showButtons && (
        <div className="mt-2">
          <button type="button" onClick={() => change && change({ currentValue: { hex: '#000000' } })} className="px-2 py-1 border rounded mr-2">OK</button>
          <button type="button" onClick={() => change && change({ currentValue: { hex: '#ffffff' } })} className="px-2 py-1 border rounded">Cancel</button>
        </div>
      )}
    </div>
  );
};

export default ColorPickerComponent;
